var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 36
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#047AB1",
    d: "M.587 36h10.165c2.313 0 5.083-2.688 5.083-4.8V0H5.67C3.357 0 .587 2.688.587 7.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.356 24.336c-1.952 0-3.894-.258-5.769-.768v-2.64c1.455.85 3.119 1.33 4.829 1.392 1.956 0 3.05-1.296 3.05-3.072V12h4.828v7.248c0 2.832-1.576 5.088-6.938 5.088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D42D06",
    d: "M18.376 36h10.165c2.313 0 5.083-2.688 5.083-4.8V0H23.459c-2.313 0-5.083 2.688-5.083 7.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.376 13.68c1.474-1.344 4.015-2.184 8.132-1.992 2.237.096 4.575.72 4.575.72v2.664a10.8 10.8 0 0 0-4.397-1.368c-3.126-.264-5.032 1.392-5.032 4.296s1.906 4.56 5.032 4.32a10.9 10.9 0 0 0 4.397-1.392v2.64s-2.338.648-4.575.744c-4.117.192-6.658-.648-8.132-1.992z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#67B637",
    d: "M36.165 36H46.33c2.313 0 5.083-2.688 5.083-4.8V0H41.248c-2.313 0-5.083 2.688-5.083 7.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.872 20.88c0 1.92-1.576 3.12-3.685 3.12h-9.022V12h8.209l.584.024c1.855.096 3.228 1.128 3.228 2.904 0 1.392-.94 2.592-2.643 2.88v.072c1.88.12 3.329 1.248 3.329 3m-6.48-6.984a2.5 2.5 0 0 0-.331-.024h-3.05v3.024h3.38c.636-.144 1.17-.696 1.17-1.512s-.534-1.368-1.17-1.488m.38 4.896a2.3 2.3 0 0 0-.406-.024H39.01v3.288h3.355l.407-.048c.635-.144 1.169-.768 1.169-1.608s-.509-1.44-1.17-1.608"
  })));
};
export default SvgJcb;